import DatePicker from 'components/DatePicker'
import React from 'react'
import styles from 'components/FormControls/form-controls.module.scss'

const renderDatePickerField = ({
  input,
  parseDate = (val) => val,
  mode = 'date-range',
  meta: { touched, error, submitting },
  t = () => {},
  meta,
  InputProps = {},
  helperText = null,
  fullWidth = false,
  hidden = false,
  readOnly = false,
  placeholder = '',
  label = '',
  minDate = undefined,
  maxDate = undefined,
  disabled = false,
}) => {
  return (
    <DatePicker
      meta={meta}
      mode={mode}
      minDate={minDate}
      maxDate={maxDate}
      fullWidth={fullWidth}
      hidden={hidden}
      readOnly={readOnly}
      placeholder={placeholder}
      label={label}
      value={parseDate(input.value)}
      ControlProps={InputProps}
      onChange={input.onChange}
      touched={touched}
      disabled={disabled || submitting}
      error={touched && error ? error : null}
      helperText={touched && error ? t(error) : helperText}
      buttonClassName={styles['date-picker__button']}
      asButton={false}
      popoverConfig={{
        variant: 'popover',
        id: 'datePickerPopover',
        breakpoints: {
          0: {
            variant: 'bottomSheet',
            hasBackdrop: true,
            showLabel: true,
            label: t(label),
          },
          768: {
            variant: 'popover',
            hasBackdrop: false,
          },
        },
      }}
    />
  )
}

export default renderDatePickerField
